import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { dateAsString } from '../../shared/date.helper';
import { FlagGroup, Inspection } from '../../shared/interfaces';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FlagService } from '../../flag/flag.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-extension-granted-deadlines',
  templateUrl: './extension-granted-deadlines.component.html',
  styleUrls: ['./extension-granted-deadlines.component.scss'],
})
export class ExtensionGrantedDeadlinesComponent implements OnInit {
  @ViewChild('setDatesModal', { static: true }) public setDatesModal: ModalDirective;
  @Input() selectedFlags: any;
  @Output() deadlinesUpdated = new EventEmitter<void>();
  confirmCallback: () => void;
  cancelCallback: () => void;
  inspection: Inspection;
  loading = false;
  addDateForm: UntypedFormGroup;
  selectedTabIndex: number = 0;

  dateConfig = { dateInputFormat: 'MM-DD-YYYY', customTodayClass: 'date-today' };
  saving = false;

  constructor(
    private fb: UntypedFormBuilder,
    private flagService: FlagService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.addDateForm = this.fb.group({
      violationActionRequiredDeadline: ['', [Validators.required, this.dateAfterTodayValidator]],
      reason: ['', Validators.required],
    });

    const defaultDate = new Date();
    defaultDate.setDate(defaultDate.getDate() + 30);
    this.addDateForm.get('violationActionRequiredDeadline').setValue(dateAsString(defaultDate));

    this.setDatesModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  show(options: { confirmed?: () => void; canceled?: () => void; inspection: Inspection }) {
    this.loading = true;
    this.confirmCallback = options.confirmed;
    this.cancelCallback = options.canceled;
    this.inspection = options.inspection;

    // Reset form and set default 30-day date
    this.addDateForm.reset();
    const defaultDate = new Date();
    defaultDate.setDate(defaultDate.getDate() + 30);
    this.addDateForm.get('violationActionRequiredDeadline').setValue(dateAsString(defaultDate));

    this.selectedTabIndex = 0;

    if (this.inspection.dueDate) {
    }
    this.cdr.detectChanges();
    this.setDatesModal.show();
    this.loading = false;
  }

  async save() {
    if (this.saving) return;
    this.loading = true;
    if (this.addDateForm.valid) {
      this.saving = true;
      const flagIds = this.selectedFlags.map(flag => flag.id);
      this.flagService.setFlagsDeadline({ flagIds, ...this.addDateForm.value }).then(() => {
        this.addDateForm.reset();
        this.setDatesModal.hide();
        this.saving = false;
        this.loading = false;
        this.toastr.success('Extension granted');
        this.deadlinesUpdated.emit();
        return this.confirmCallback && this.confirmCallback();
      });
      this.setDatesModal.hide();
      this.saving = false;
    }
    this.loading = false;
  }

  cancel() {
    this.setDatesModal.hide();
    return !!this.cancelCallback && this.cancelCallback();
  }

  onTabChange(days: number): void {
    if (days) {
      const targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + days);
      this.addDateForm.get('violationActionRequiredDeadline').setValue(dateAsString(targetDate));
      this.selectedTabIndex = days === 30 ? 0 : days === 60 ? 1 : 2;
    }
  }

  onDeadlineChange(value: string): void {
    this.addDateForm.get('violationActionRequiredDeadline').setValue(value);
  }

  onReasonChange(value: string): void {
    this.addDateForm.get('reason').setValue(value);
  }

  dateAfterTodayValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const selectedDate = new Date(control.value);
    const today = new Date();

    today.setHours(0, 0, 0, 0);

    if (selectedDate <= today) {
      return { dateInvalid: true };
    }

    return null;
  }
}
